import React from "react";
import "./activateCard.css";

const ActivateCard = ({
  close,
  action,
  msg = "Are you sure you want to perform this action ?",
}) => {
  return (
    <div className="delete-card-overlay">
    <div className="delete-card">
      <p>{msg}</p>
      <div className="action-box">
        <button onClick={action}>Proceed</button>
        <button onClick={close}>No</button>
      </div>
    </div>
    </div>
  );
};

export default ActivateCard;
